const ORDER_VERIFICATION_TABLE_READY = "order-verification-table-ready"
const SEARCH_TEXT_STATE = "order-verification-table-search-text-state"
const ROWS_PER_PAGE_STATE = "order-verification-table-rows-per-page-state"
const PAGINATION_STATE = "order-verification-table-pagination-state"

const ORDER_VERIFICATION_ID_FOR_ACTION = "order-verification-table-brand-id-for-action"

const ORDER_VERIFICATION_UPDATE_READY = "add-edit-order-verification-ready"


const PREVIOUS_ORDER_VERIFICATION_FILTER_START_DATE = "order-verification-previous-start-date"
const PREVIOUS_ORDER_VERIFICATION_FILTER_END_DATE = "order-verification-previous-end-date"
const PREVIOUS_ORDER_VERIFICATION_FILTER_CITY = "order-verification-previous-city"
const PREVIOUS_ORDER_VERIFICATION_FILTER_KITCHEN = "order-verification-previous-kitchen"
const PREVIOUS_ORDER_VERIFICATION_FILTER_STORE = "order-verification-previous-store"
const PREVIOUS_ORDER_VERIFICATION_FILTER_STATUS = "order-verification-previous-status"
const PREVIOUS_ORDER_VERIFICATION_FILTER_PLATFORM = "order-verification-previous-platform"

const initialState = {
    isOrderVerificationTableReady: true,
    isOrderVerificationUpdateReady:true,
    orderVerification: {},

   
    previousFilterStartDate: "",
    previousFilterEndDate: "",
    previousFilterCity: "",
    previousFilterStatus: "",
    previousFilterKitchen: "",
    previousFilterStore: "",
    previousFilterPlatform: "",
    
    storeSelectedId: null,
    
    orderVerificationSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case ORDER_VERIFICATION_TABLE_READY:
            return Object.assign({}, state, { isOrderVerificationTableReady: action.payload })
        case ORDER_VERIFICATION_UPDATE_READY:
            return Object.assign({}, state, { isOrderVerificationUpdateReady: action.payload })
        


        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case ORDER_VERIFICATION_ID_FOR_ACTION:
            return Object.assign({}, state, {orderVerificationSelectedId:action.payload})




        case PREVIOUS_ORDER_VERIFICATION_FILTER_START_DATE:
            return Object.assign({}, state, {previousFilterStartDate:action.payload})
        case PREVIOUS_ORDER_VERIFICATION_FILTER_END_DATE:
            return Object.assign({}, state, {previousFilterEndDate:action.payload})
        case PREVIOUS_ORDER_VERIFICATION_FILTER_CITY:
            return Object.assign({}, state, {previousFilterCity:action.payload})
        case PREVIOUS_ORDER_VERIFICATION_FILTER_STATUS:
            return Object.assign({}, state, {previousFilterStatus:action.payload})
        case PREVIOUS_ORDER_VERIFICATION_FILTER_KITCHEN:
            return Object.assign({}, state, {previousFilterKitchen:action.payload})
            
        case PREVIOUS_ORDER_VERIFICATION_FILTER_STORE:
            return Object.assign({}, state, {previousFilterStore:action.payload})
        case PREVIOUS_ORDER_VERIFICATION_FILTER_PLATFORM:
            return Object.assign({}, state, {previousFilterPlatform:action.payload})


        default:
        return state
    
    }

}

export function orderVerificationTableReady(data) {
    return {
        type: ORDER_VERIFICATION_TABLE_READY,
        payload: data
    }
}


export function orderVerificationUpdateReady(data) {
    return {
        type: ORDER_VERIFICATION_UPDATE_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function orderVerificationIdForAction(brandId){
    return{
        type:ORDER_VERIFICATION_ID_FOR_ACTION,
        payload:brandId
    }
}



export function previousFilterStartDate(fiter_val){
    return{
        type:PREVIOUS_ORDER_VERIFICATION_FILTER_START_DATE,
        payload:fiter_val
    }
}


export function previousFilterEndDate(fiter_val){
    return{
        type:PREVIOUS_ORDER_VERIFICATION_FILTER_END_DATE,
        payload:fiter_val
    }
}



export function previousFilterCity(fiter_val){
    return{
        type:PREVIOUS_ORDER_VERIFICATION_FILTER_CITY,
        payload:fiter_val
    }
}


export function previousFilterStatus(fiter_val){
    return{
        type:PREVIOUS_ORDER_VERIFICATION_FILTER_STATUS,
        payload:fiter_val
    }
}


export function previousFilterKitchen(fiter_val){
    return{
        type:PREVIOUS_ORDER_VERIFICATION_FILTER_KITCHEN,
        payload:fiter_val
    }
}




export function previousFilterStore(fiter_val){
    return{
        type:PREVIOUS_ORDER_VERIFICATION_FILTER_STORE,
        payload:fiter_val
    }
}

export function previousFilterPlatform(fiter_val){
    return{
        type:PREVIOUS_ORDER_VERIFICATION_FILTER_PLATFORM,
        payload:fiter_val
    }
}



// WEBPACK FOOTER //
// ./src/modules/Order Verification/redux/order_verification.js